import { lightTheme } from '@/customTheme'
import ButtonCustom from '@/components/ButtonCustom'
import { SizeButton } from '@/constants/sizeButton'
import { KIND } from 'baseui/button'
import { selectUser } from '@/store/slices/user/selectors'
import { useSelector } from 'react-redux'
import { useEffect, useRef } from 'react'
import { useAppDispatch } from '@/store/store'
import { setOpenModalTryPremium } from '@/store/slices/user/actions'
import { useTranslation } from 'react-i18next'
import { customAmplitude } from '@/utils/customAmplitude'
import useModal from '@/hooks/useModal'
import Icons from '@/scenes/Editor/components/Icons'
import { WrapAutoScroll } from '@/components/AutoScroll/AutoScroll'

interface WhatsNewTwoColumnProps {
  data: any[]
  onClose: () => void
}

function WhatsNewTwoColumn({ data, onClose }: WhatsNewTwoColumnProps) {
  const user = useSelector(selectUser)
  const { setShowModalType } = useModal()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const video = videoRef.current
    return () => {
      video?.pause()
    }
  }, [])

  const onClickPrimaryButton = e => {
    e.preventDefault()
    e.stopPropagation()
    if(!user || !user.userIsPremium) {
      dispatch(
        setOpenModalTryPremium({
          isOpen: true,
          source: 'BtSubscriptionWhatsNew',
          callback: () => {
          }
        })
      )
      customAmplitude('Premium Prompt', {
        Source: 'BtSubscriptionWhatsNew',
        Type: 'Standard',
      })
      customAmplitude('Whats New - Try Premium')
    }
    setShowModalType(null)
  }

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        maxWidth: '920px ',
        maxHeight: '652px',
        minWidth: '920px ',
        minHeight: '652px',
        flexDirection: 'row',
        background: 'rgba(255, 255, 255, 1)',
        borderRadius: '16px',
        overflow: 'hidden',
        position: 'absolute',
        display: 'flex',
      }}
      id="modal-what-new"
    >
      <WrapAutoScroll
        style={{
          padding: '232px 39px 0 32px',
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'left',
          width: '50%',
          justifyContent: 'start'
        }}
      >
        <h2 style={{ margin: 0, ...lightTheme.typography.Small16Bold }}>
          {t('New in Bazaart')}
        </h2>
        <h4
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '8px',
            margin: '4px 0 32px 0',
            ...lightTheme.typography.Title32Bold,
            fontFamily: 'ES-Rebond-Grotesque-Classic, Rubik, Roboto',
          }}
        >
          {t(data[0]?.text)}
        </h4>
        <ButtonCustom
          type={SizeButton.LARGE}
          kind={KIND.primary}
          style={{
            position: 'relative',
            ...lightTheme.typography.Small14Semibold,
            color: '#fff',
            margin: 0,
            minWidth: '165px',
            width: 'fit-content'
          }}
          onClick={e => onClickPrimaryButton(e)}
        >
          {user?.userIsPremium ? t('Got it!') : t('Try it free')}
        </ButtonCustom>
      </WrapAutoScroll>
      <div
        style={{
          width: '50%',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          paddingLeft: 0,
          background: 'rgba(249, 249, 249, 1)',
        }}
      >
        <video
          ref={videoRef}
          width="100%"
          height="100%"
          style={{
            objectFit: 'cover',
          }}
          loop
          autoPlay
          muted
          playsInline
          src={data[0].video}
        />
      </div>
      <div
        style={{
          position: 'absolute',
          top: '16px',
          right: '16px',
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={e => {
          e.stopPropagation()
          onClose()
        }}
      >
        <Icons.WhiteCloseIcon size={24} />
      </div>
    </div>
  )
}

export default WhatsNewTwoColumn
